import * as React from 'react';
import { Financials } from '@bb/domain/dist/types';

import DataSetsTable from './DataSetsTable';

type FinancialDetailsProps = {
  financials: Financials;
};

const FinancialDetails: React.FunctionComponent<FinancialDetailsProps> = ({
  financials,
}) => {
  const financialDetailsDataSets = [
    [
      { label: 'Taxes:', value: financials.taxes },
      { label: 'Insurance:', value: financials.insurance },
      { label: 'Management:', value: financials.management },
      { label: 'Maintenance:', value: financials.maintenance },
      { label: 'Heat:', value: financials.heat },
      { label: 'Hydro:', value: financials.hydro },
      { label: 'Water:', value: financials.water },
    ],
    [
      { label: 'Gross Income/Sales:', value: financials.gross_income },
      { label: 'Vacancy Allowance:', value: financials.vacancy_allowance },
      { label: 'Operating Expenses:', value: financials.operating_expenses },
      { label: 'Net Income:', value: financials.net_income },
      { label: 'Expenses:', value: financials.expenses },
      { label: 'Year Expenses:', value: financials.year_expenses },
      { label: 'Cap Rate(%):', value: financials.cap_rate },
      { label: 'Financial Avail:', value: financials.available },
    ],
  ];

  return <DataSetsTable dataSets={financialDetailsDataSets} />;
};

export default FinancialDetails;
